<script>
export default {
  computed: {
    tv () {
      return this.docs.onair.tv
    },
    nf () {
      return this.docs.onair.nf
    }
  }
}
</script>

<template>
  <div class="gp-onair">
    <div class="page-background"></div>
    <header>
      <h1 class="page-title">ONAIR</h1>
    </header>
    <div class="contents-container">
      <section class="tv has-text-weight-bold has-text-align-center">
        <h1 class="is-size-2 is-size-4-mobile">
          <span>TV放送</span>
        </h1>
        <h2>
          <span>フジテレビ「＋Ultra」<br>他各局にて放送</span>
        </h2>
        <div class="onair-list">
          <ul class="has-text-weight-bold is-size-4 is-size-6-mobile">
            <li
              class="level is-mobile has-text-align-left"
              v-for="(item, index) in tv"
              :key="index"
            >
              <span class="name">{{ item.name }}</span>
              <span>{{ item.date }}</span>
              <span class="time">{{ item.time }}</span>
            </li>
          </ul>
        </div>
        <div class="is-size-4 is-size-6-mobile has-text-weight-normal">
          <p>※放送日時は変更の可能性があります。</p>
        </div>
      </section>
      <section class="nf has-text-weight-bold has-text-align-center">
        <h1 class="is-size-2 is-size-4-mobile">
          <span>配信</span>
        </h1>
        <h2>
          <span>Netflixにて好評配信中</span>
        </h2>
        <div class="onair-list">
          <ul class="has-text-weight-bold is-size-4 is-size-6-mobile">
            <li
              class="level is-mobile has-text-align-left"
              v-for="(item, index) in nf"
              :key="index"
            >
              <span class="name">{{ item.name }}</span>
              <span>{{ item.date }}</span>
            </li>
          </ul>
        </div>
        <h2 class="fod">
          <span>FODほかでも配信中</span>
        </h2>
        <div>
          <a
            href="https://fod.fujitv.co.jp/s/genre/anime/ser5f65/"
            target="_blank"
            rel="noopener"
          >
            <img
              class="logo-fod"
              src="/assets/images/logo-fod_2x.png"
              alt="FOD"
            >
          </a>
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gp-onair {
  .contents-container {
    @include is-not-mobile  {
      max-width: 60rem;
      padding: 0 2rem;
      margin: auto;
    }
  }
  .page-title {
    @include is-mobile {
      margin-bottom: 2.5rem;
    }
  }
  section {
    @include is-mobile {
      margin-bottom: 2.5rem;
    }
    @include is-not-mobile {
      margin-bottom: 4.5rem;
    }
    h1 {
      color: $orange;
      background-color: $black;
      line-height: 2rem;
      @include is-mobile {
        margin: 0 1rem 1.25rem;
      }
      @include is-not-mobile {
        width: 22rem;
        margin: auto;
      }
    }
    h2 {
      @include is-mobile {
        font-size: 1.875rem;
        margin: 0 1.5rem;
        line-height: 2.25rem;
      }
      @include is-not-mobile {
        font-size: 2.5rem;
        margin: 1.5rem;
        line-height: 3rem;
      }
    }
    .fod {
      margin-top: 2.5rem;
      @include is-mobile {
        margin-bottom: 1.5rem;
      }
    }
    .logo-fod {
      width: 200px;
    }
    p {
      margin: 1rem 1.5rem;
    }
    .onair-list {
      background-color: $black-transparent;
      @include is-mobile {
        padding: .25rem 3.25rem;
        margin: 1.25rem 1rem 1rem;
      }
      @include is-not-mobile {
        padding: .25rem;
      }
      ul {
        @include is-not-mobile {
          width: 25rem;
          margin: auto;
        }
        li {
          color: $white;
          @include is-mobile {
            margin: 1rem 0;
          }
          @include is-not-mobile {
            margin: 1.5rem 0;
          }
          span {
            white-space: nowrap;
            @include is-mobile {
              width: 9rem;
            }
            @include is-not-mobile {
              width: 11rem;
            }
          }
          .name {
            color: $orange;
          }
          @include is-mobile {
            .name {
              min-width: 9rem;
            }
          }
          @include is-not-mobile {
            .name {
              min-width: 8rem;
            }
            .time {
              min-width: 11rem;
            }
          }
        }
      }
    }
    &.tv .onair-list {
      @include is-mobile {
        padding: .25rem .75rem;
        margin: 1.25rem 1rem 1rem;
      }
      ul {
        @include is-not-mobile {
          width: 27.5rem;
          margin: auto;
        }
        @include is-mobile {
          .name {
            min-width: 5.5rem;
          }
          .time {
            min-width: 8rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/onair.vue